// @flow
import OrgsOrdersPage, { dataKey } from './OrgsOrdersPage';

export default OrgsOrdersPage;
export { dataKey };
